var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-overlay',{attrs:{"show":_vm.unitLoad}},[_c('add-owner-officers',{attrs:{"items":_vm.officers,"type":2,"title":"Offiers Inforamtion"}}),_c('add-owner-officers',{attrs:{"items":_vm.officers,"type":1,"title":"Owner Inforamtion"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }